export type WhatsappAccountConnectionMessages = {
  whatsappAccountConnectionText1: string;
  whatsappAccountConnectionText2: string;
  whatsappAccountConnectionText3: string;
  whatsappAccountConnectionImportantNote: string;
  whatsappAccountConnectionWhatsappServiceTermsText: string;
  whatsappAccountConnectionWhatsappServiceTermsSource: string;
  connectWithFacebookButton: string;
};

export const whatsappAccountConnectionMessages: WhatsappAccountConnectionMessages = {
  whatsappAccountConnectionText1:
    "Conecte-se a uma conta Facebook com permissão de administrador no Gerenciador de Negócios da sua empresa, é só seguir as instruções do próprio Facebook para configurar sua conexão.",
  whatsappAccountConnectionText2:
    "Em seguida, você poderá utilizar os agentes da Talk2Buy já publicados para iniciar suas vendas no WhatsApp.",
  whatsappAccountConnectionText3:
    "Ao prosseguir com a ativação do número, é importante que você esteja ciente e concorde com os ",
  whatsappAccountConnectionImportantNote:
    "Importante: Deixe essa aba aberta durante o processo externo.", // Nova mensagem adicionada
  whatsappAccountConnectionWhatsappServiceTermsText: "Termos de Serviço do WhatsApp Business",
  whatsappAccountConnectionWhatsappServiceTermsSource:
    "https://www.whatsapp.com/legal/business-terms?lang=pt_BR",
  connectWithFacebookButton: "Conectar com Facebook",
};
